import { render, staticRenderFns } from "./conversation-detail-drawer.vue?vue&type=template&id=538b3a5e&"
import script from "./conversation-detail-drawer.vue?vue&type=script&lang=ts&"
export * from "./conversation-detail-drawer.vue?vue&type=script&lang=ts&"
import style0 from "./conversation-detail-drawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports